import { render, staticRenderFns } from "./mdlUserroleChange.vue?vue&type=template&id=344f17ca"
import script from "./mdlUserroleChange.vue?vue&type=script&lang=js"
export * from "./mdlUserroleChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports